<template>
  <div>
    <div class="mb-8">
      <v-img :src="previewImage(image)" width="200px">
        <template v-slot:placeholder>
          <div class="image-placeholder"></div>
        </template>
      </v-img>
    </div>
    <div style="width: 264px; max-width: 100%;">
      <v-file-input label="Фон" prepend-icon="" outlined class="cursor-pointer"
                    v-model="image">
      </v-file-input>
    </div>
    <v-btn @click="save" :loading="isLoading">Сохранить</v-btn>
    <v-snackbar v-model="snackbar" :timeout="timeout" :color="snackbarColor" right top>
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>
// @ is an alias to /src


import SettingService from "@/api/SettingService";
import ProductService from "@/api/ProductService";

export default {
  name: 'HomeIndex',
  components: { },
  data: () => ({
    isLoading: false,
    image: null,
    settingId: null,
    snackbar: false,
    timeout: 2000,
    snackbarText: "",
    snackbarColor: "",
  }),
  mounted() {
    SettingService.get('home-bg').then(response => {
      if (response.data && response.data.id) {
        this.image = {}
        this.settingId = response.data.id;
        this.image.url = response.data.value;
        this.image.name = response.data.value;
      }

    })
  },
  watch: {},
  methods: {
    previewImage(image) {
      if (this.image && this.image.url) {
        return 'https://esho.od.ua' +this.image.url;
      }
      if (image) {
        return URL.createObjectURL(image);
      }
    },
    save(){
      this.isLoading = true
      let formData = new FormData();

      if (this.image && !this.image.url) {
        formData.append("image", this.image);
      }
      else if (this.image && this.image.url) formData.append("image", this.image.url);



      SettingService.update(this.settingId, formData)
          .then((response) => {
            this.isLoading = false
            this.snackbar = true;
            this.snackbarText = "Сохранено";
            this.snackbarColor = "success";
          })
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
